module.exports = __webpack_public_path__ + "resource/img/default-icon.0669bcd3.jpg";